import React from "react";
import unsplash from "../images/Unsplash.png";
import zostel from "../images/Zostel.png";
import overstock from "../images/Overstock.png";
import amazon from "../images/Amazon.png";

const Projects = () => {
    return (
        <section class="projects" id="projects">
            <h2 class="heading"><span>My</span> Projects</h2>
            <div class="projects-contaner">
                <div class="project-box">
                    <img src={overstock} alt="" />
                    <div class="project-layer">
                        <h4>Overstock Clone</h4>
                        <p>
                            An American E-commerce Retailer of furniture and home decor.
                            My contribution to this project was Developed the Cart & Payment Page of the Website from Scratch.
                            The rest of the project was built by various members of the group.
                        </p>
                        <p><b>Tech Stack:</b> HTML, CSS, JS, VSCode, Git, Local Storage</p>
                        <div class="projecti">
                            <a href="https://playful-starburst-806a16.netlify.app/" target="_blank"><box-icon color="#2a303b" name='link-external'></box-icon></a>
                            <a href="https://github.com/Ajay-bhagal/team_12" target="_blank"><box-icon color="#2a303b" name='github' type='logo' ></box-icon></a>
                        </div>
                    </div>
                </div>

                <div class="project-box">
                    <img src={unsplash} alt="" />
                    <div class="project-layer">
                        <h4>Unsplash Clone</h4>
                        <p>
                            A website dedicated to proprietary stock photography.
                            My contribution to this project was Developed the Explore Page with search functionality of the Website from Scratch
                            & Implemented Various JS functionalities on different pages of the Web-App.
                            The rest of the project was built by various members of the group.
                        </p>
                        <br />
                        <p><b>Tech Stack:</b> HTML, CSS, JS, VSCode, Git, Local Storage, API</p>
                        <div class="projecti">
                            <a href="https://soft-cucurucho-b7b394.netlify.app/" target="_blank"><box-icon color="#2a303b" name='link-external'></box-icon></a>
                            <a href="https://github.com/Ajay-bhagal/team_6" target="_blank"><box-icon color="#2a303b" name='github' type='logo' ></box-icon></a>
                        </div>
                    </div>
                </div>

                <div class="project-box">
                    <img src={zostel} alt="" />
                    <div class="project-layer">
                        <h4>Zostel Clone</h4>
                        <p>
                            A website of hostels and homes in India. It has presence in 44 cities in India and Nepal.
                            My contribution to this project was Developed the landing page of the Website from Scratch.
                            The rest of the project was built by various members of the group.
                        </p>
                        <p><b>Tech Stack:</b> HTML, CSS, JS, React, Context-Api, VSCode, Git, Local Storage, API</p>
                        <div class="projecti">
                            <a href="https://zostelreactclone.vercel.app/" target="_blank"><box-icon color="#2a303b" name='link-external'></box-icon></a>
                            <a href="https://github.com/rachnarajaka040/Zostel.com_clone" target="_blank"><box-icon color="#2a303b" name='github' type='logo' ></box-icon></a>
                        </div>
                    </div>
                </div>

                <div class="project-box">
                    <img src={amazon} alt="" />
                    <div class="project-layer">
                        <h4>Amazon Clone</h4>
                        <p>
                            An American multinational technology company focusing on e-commerce, cloud computing, online advertising, digital streaming, and artificial intelligence
                        </p>
                        <br />
                        <p><b>Tech Stack:</b> •HTML, CSS, React, MUI, Node.js, express.js, MongoDB, VSCode, Git, Local Storage.</p>
                        <div class="projecti">
                            <a href="https://amazonclone-tau-blush.vercel.app/" target="_blank"><box-icon color="#2a303b" name='link-external'></box-icon></a>
                            <a href="https://github.com/Ayankar84/amazon_clone" target="_blank"><box-icon color="#2a303b" name='github' type='logo' ></box-icon></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default Projects